import { render, staticRenderFns } from "./Preview.vue?vue&type=template&id=bfac2ec0&scoped=true&"
import script from "./Preview.vue?vue&type=script&lang=ts&"
export * from "./Preview.vue?vue&type=script&lang=ts&"
import style0 from "./Preview.vue?vue&type=style&index=0&id=bfac2ec0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfac2ec0",
  null
  
)

export default component.exports